import { connect } from 'react-redux';
import ConfirmDeleteModal from './shared/confirm_delete_modal.jsx';

import {
  closeModal
} from 'zoomforth_codesbane_editor/action_creators/editor_modals.js';

import {
  deleteContentItemFromOrderedContentSection
} from 'zoomforth_codesbane_editor/action_creators/sections.ordered_content.js';

import {
  getDisplayableContentDescriptor
} from 'zoomforth_codesbane_viewer/lib/page_content_utils.js';

const mapStateToProps = (state, { section, contentItem }) => {
  return {
    title: 'Really delete video?',
    body: `You are about to delete this ${getDisplayableContentDescriptor(section, contentItem)}. This cannot be undone.`,
    confirmText: 'Delete Video',
    cancelText: 'Cancel'
  };
};


const mapDispatchToProps = (dispatch, { contentItem }) => (
  {
    onCancel: ()=> { 
      dispatch(closeModal()); 
    },
    onConfirm: ()=> { 
      dispatch(deleteContentItemFromOrderedContentSection(contentItem));
      dispatch(closeModal());
    }
  }
);

const ConfirmDeleteVideoplaylistItemModal = connect(
  mapStateToProps,
  mapDispatchToProps
)(ConfirmDeleteModal);

ConfirmDeleteVideoplaylistItemModal.editorModalName = 'ConfirmDeleteVideoplaylistItemModal';

export default ConfirmDeleteVideoplaylistItemModal;
